import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import http from "../services/http-common";
import { sortBy } from "lodash";
import useUserRole from "./useUserRole";
import { useMsal } from "@azure/msal-react";

const useGetAllUserListOption = (consultantOnly = false) => {
  const { usersInfos } = useSelector((state) => ({ ...state.userInfos }));
  const { isAdmin, hasAccessAsDeveloper } = useUserRole();
  const [userOptions, setUserOptions] = useState([]);
  const [error, setError] = useState("");
  const [loaded, setLoaded] = useState(false);
  const { accounts } = useMsal();

  const connectedUserId = accounts[0]?.idTokenClaims?.oid;

  const buildOption = (user) => {
    const hasRoleAccess = isAdmin || hasAccessAsDeveloper || (!isAdmin && user?.operatingManagerId === connectedUserId);
    const hasConsultantRole = !consultantOnly || user.role === 1 || user.role === 2;
    return hasRoleAccess && hasConsultantRole;
  };

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        if (!usersInfos || !usersInfos?.data) {
          setLoaded(false);
          const response = await http.get(`/user?getPrivateStats=false`);

          if (isMounted) {
            let options = [];
            if (response && response.data) {
              response.data.forEach((user) => {
                if (buildOption(user)) {
                  options.push({ value: user.userId, label: `${user.firstName} ${user.lastName}`, isActivated: user.isActivated });
                }
              });
            }
            setUserOptions(sortBy(options, "label"));
            setError(null);
          }
        } else {
          let options = [];
          usersInfos?.data.forEach((user) => {
            if (buildOption(user)) {
              options.push({ value: user.userId, label: `${user.firstName} ${user.lastName}`, isActivated: user.isActivated });
            }
          });
          setUserOptions(sortBy(options, "label"));
          setError(null);
        }
      } catch (error) {
        if (isMounted) {
          setError(error.message);
          setUserOptions([]);
        }
      } finally {
        if (isMounted) {
          setLoaded(true);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  return { userOptions, error, loaded };
};

export default useGetAllUserListOption;
